export default "__VITE_ASSET__BtHVOGw9__"